import CountUp from "react-countup";
import { cediSign } from '../../utils/constants';

function NumCount({ symbol, number, deci }) {
    return (
        <CountUp
            className="account-balance"
            start={0}
            end={number}
            formattingFn={(value) => {
                return symbol ? `${cediSign} ${value.toLocaleString()}` : value.toLocaleString();
            }}
            duration={2.75}
            separator=""
            decimals={deci ? 2 : 0}
            decimal={deci}
            prefix={symbol ? `${symbol} ` : ""}
            suffix=""
        />
    )
}

export default NumCount